export default __webpack_public_path__ + "static/gatsby-icon-9a58caa0a29816744077eb0e273e944f.png";